var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState, useRef } from '@max/max';
import { CardDataStrategyFactory } from './useCardDataStrategy';
/**
 * 统一的卡片数据加载 Hook
 * 自动根据样式类型选择合适的加载策略
 */
export const useCardData = ({ styleType, cityId, props, texReportData, ctx }) => {
    const [cardList, setCardList] = useState([]);
    const [showLoadMore, setShowLoadMore] = useState(false);
    // 使用 ref 存储策略实例，避免重复创建
    const strategyRef = useRef(null);
    // 是否是首次请求
    const isFirstRequest = useRef(true);
    /**
     * 重置缓存
     */
    const resetCache = () => {
        if (strategyRef.current) {
            strategyRef.current.reset();
        }
    };
    /**
     * 加载更多
     */
    const loadMore = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!strategyRef.current)
            return;
        yield strategyRef.current.loadMore();
        updateDisplay();
    });
    /**
     * 更新显示的卡片列表
     */
    const updateDisplay = () => {
        if (!strategyRef.current)
            return;
        setCardList([...strategyRef.current.getDisplayList()]);
        setShowLoadMore(strategyRef.current.hasMore());
    };
    useEffect(() => {
        strategyRef.current = new CardDataStrategyFactory().createStrategy(styleType, cityId, props, texReportData, ctx);
    }, []);
    /**
     * 城市改变时重置并重新加载首页
     */
    useEffect(() => {
        if (isFirstRequest.current && props.isLinkageCityFilter) {
            isFirstRequest.current = false;
        }
        else {
            loadFirstPage();
        }
    }, []);
    const cityChangeCallback = (cityId) => {
        var _a;
        resetCache();
        (_a = strategyRef.current) === null || _a === void 0 ? void 0 : _a.setCityId(cityId);
        loadFirstPage();
    };
    /**
     * 加载首页数据
     */
    const loadFirstPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!strategyRef.current)
            return;
        yield strategyRef.current.loadFirstPage();
        updateDisplay();
    });
    return {
        cardList,
        showLoadMore,
        loadMore,
        resetCache,
        cityChangeCallback
    };
};
